@if (notification) {
  <div class="notification notification--{{ notification.level | lowercase }}">
    <span class="notification__message">{{ notification.message }}</span>
    @if (notification.link) {
      <a class="notification__link" [routerLink]="notification.link.commands" (click)="dismiss()">{{ notification.link.label }}</a>
    }
    <button class="notification__close" (click)="dismiss()">✕</button>
  </div>
}
